/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_In_StockInputs */

const en_val_in_stock = /** @type {(inputs: Val_In_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Stock`)
};

const id_val_in_stock = /** @type {(inputs: Val_In_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stok Tersedia`)
};

/** @type {(inputs: Val_In_StockInputs) => LocalizedString} */
const es_val_in_stock = en_val_in_stock;

/** @type {(inputs: Val_In_StockInputs) => LocalizedString} */
const fr_val_in_stock = en_val_in_stock;

/** @type {(inputs: Val_In_StockInputs) => LocalizedString} */
const de_val_in_stock = en_val_in_stock;

/** @type {(inputs: Val_In_StockInputs) => LocalizedString} */
const ja_val_in_stock = en_val_in_stock;

/** @type {(inputs: Val_In_StockInputs) => LocalizedString} */
const zh_val_in_stock = en_val_in_stock;

/** @type {(inputs: Val_In_StockInputs) => LocalizedString} */
const ar_val_in_stock = en_val_in_stock;

/** @type {(inputs: Val_In_StockInputs) => LocalizedString} */
const it_val_in_stock = en_val_in_stock;

/** @type {(inputs: Val_In_StockInputs) => LocalizedString} */
const ru_val_in_stock = en_val_in_stock;

/** @type {(inputs: Val_In_StockInputs) => LocalizedString} */
const pt_val_in_stock = en_val_in_stock;

/** @type {(inputs: Val_In_StockInputs) => LocalizedString} */
const ko_val_in_stock = en_val_in_stock;

/**
* | output |
* | --- |
* | "In Stock" |
*
* @param {Val_In_StockInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_in_stock = /** @type {((inputs?: Val_In_StockInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_In_StockInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_in_stock(inputs)
	if (locale === "es") return es_val_in_stock(inputs)
	if (locale === "fr") return fr_val_in_stock(inputs)
	if (locale === "de") return de_val_in_stock(inputs)
	if (locale === "ja") return ja_val_in_stock(inputs)
	if (locale === "zh") return zh_val_in_stock(inputs)
	if (locale === "ar") return ar_val_in_stock(inputs)
	if (locale === "id") return id_val_in_stock(inputs)
	if (locale === "it") return it_val_in_stock(inputs)
	if (locale === "ru") return ru_val_in_stock(inputs)
	if (locale === "pt") return pt_val_in_stock(inputs)
	return ko_val_in_stock(inputs)
});